import Vue from 'vue'
import Vuex from 'vuex'
import scorm from '@shared/utils/scormHandler'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stepIndex: 0,
    steps: ['intro', 'planningGame', 'plan-1', 'plan-2', 'plan-3', 'planningOutro'],
    planningIndex: 0,
    plannings: [
      {
        name: 'plan-1',
        image: 'plan1_ok.png',
        label: '1',
        answer: '',
        goodAnswer: true,
        correction: 'Il y a quelques heures excédentaires mais c’est parfois inévitable. On retrouve l’essentiel : le congé paternité, les samedis programmés et les RTT anticipés. Chapeau, vous avez même pu décaler le repos de Guillaume.'
      },
      {
        name: 'plan-2',
        image: 'plan2_faux.png',
        label: '2',
        answer: '',
        goodAnswer: false,
        correction: 'Le congé paternité est d’une durée de 11 jours calendaires à prendre par journée complète. Le congé d’Eric ne respecte pas la règle légale de pose (1er d’absence jusqu’à la veille de la reprise). Très peu de RTT ont été posés. Nicolas en a 9 en solde à gérer d’ici fin décembre.'
      },
      {
        name: 'plan-3',
        image: 'plan3_acceptable.png',
        label: '3',
        answer: '',
        goodAnswer: true,
        correction: 'Certains samedis génèrent des heures excédentaires et toutes les récupérations prévues n’ont pas plus être posées mais dans l’ensemble, les priorités sont gérées.'
      }
    ]
  },
  getters: {
    currentStep (state) {
      return state.steps[state.stepIndex]
    },
    progress (state) {
      return state.stepIndex / (state.steps.length - 1) * 100
    },
    status (state, getters) {
      return getters.progress === 100 ? 'passed' : 'incomplete'
    },
    currentPlanning (state) {
      return state.plannings[state.planningIndex]
    },
    score (state) {
      return state.plannings.filter(plan => plan.answer === plan.goodAnswer).length
    }
  },
  mutations: {
    loadState (state, datas) {
      state.stepIndex = datas.stepIndex
    },
    nextStep (state) {
      state.stepIndex++
    },
    setCardGameScore (state, score) {
      state.cardGameScore = score
    },
    navigateTo (state, index) {
      state.stepIndex = index
    },
    setPlanIndex (state, index) {
      state.planningIndex = index
    },
    setPlanningAnswer (state, answer) {
      state.plannings[state.planningIndex].answer = answer
    }
  },
  actions: {
    next ({ state, dispatch, commit }) {
      if (state.stepIndex === state.steps.length - 1) {
        dispatch('exit')
      } else {
        commit('nextStep')
      }
    },
    navigate ({ state, commit }, stepName) {
      commit('navigateTo', state.steps.indexOf(stepName))
    },
    init ({ dispatch }) {
      scorm.initLMSConnection()
      dispatch('load')
    },
    save ({ state, getters }) {
      scorm.setDatasToLMS({
        stepIndex: state.stepIndex
      })
      scorm.writeProgressToLMS(getters.progress, getters.status)
      try {
        scorm.commitToLMS()
      } catch (e) {
        if (process.env.NODE_ENV === 'production') {
          console.log('SCORM api error : ' + e)
        }
      }
    },
    load ({ commit }) {
      if (scorm.getDatasFromLMS()) {
        commit('loadState', scorm.getDatasFromLMS())
      }
    },
    exit ({ dispatch }) {
      dispatch('save')
      scorm.exitLMSConnection()
    }
  }
})
